var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSimpleIllustrationReceiptEnvelope = function SvgSimpleIllustrationReceiptEnvelope(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 70,
    fill: "none",
    viewBox: "0 0 20 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFAF0",
    stroke: "#002140",
    strokeMiterlimit: 10,
    d: "M4.246 24.812H16.44s1.743-.329 1.743-3.06V1.932L15.875 3.91 14.04 1.65l-1.834 2.26-2.072-2.118-2.118 2.213L6.273 1.79 4.53 3.957 2.458 2.122v9.087l1.79 13.606-.002-.003Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA75A",
    stroke: "#002140",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.25 9.227H1.1V38.6h18.15V9.227Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#002140",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.25 38.6s.3-2.084-2.21-2.084H3.008c-1.85 0-1.91 2.084-1.91 2.084M10.175 9.227v27.24"
  })));
};
export default SvgSimpleIllustrationReceiptEnvelope;